module.exports = __webpack_public_path__ + "img/dataCensus_comment.a8cc4fcb.svg";